// Cache for gateway name to avoid repeated API calls
let cachedGatewayName: string | null = null;
let gatewayNamePromise: Promise<string> | null = null;

export const fetchPaymentsGatewayName = async ({
  accountID,
  shopID,
}: {
  accountID: string;
  shopID: string;
}): Promise<string> => {
  const res = await $.get(`/API/Account/${accountID}/Shop/${shopID}.json`);

  const { gatewayConfigID } = res.Shop;
  if (!gatewayConfigID) {
    return '';
  }

  const gwRes = await $.get(`/API/Account/${accountID}/GatewayConfig/${gatewayConfigID}.json`);
  const { gatewayID } = gwRes.GatewayConfig; // i.e.: "cayan" or "lightspeed-payments"
  return gatewayID;
};

/**
 * Get the payments gateway name, using cache to avoid repeated API calls
 */
export const getCachedGatewayName = async (): Promise<string> => {
  // Return cached value if available
  if (cachedGatewayName !== null) {
    return cachedGatewayName;
  }

  // Return existing promise if fetch is already in progress
  if (gatewayNamePromise !== null) {
    return gatewayNamePromise;
  }

  await window.merchantos.session.init();

  // Start new fetch and cache the promise to prevent duplicate requests
  gatewayNamePromise = fetchPaymentsGatewayName({
    accountID: window.merchantos.session.getSystemCustomerID()?.toString() ?? '',
    shopID: window.merchantos.session.getShop()?.shopID?.toString() ?? '',
  });

  try {
    cachedGatewayName = await gatewayNamePromise;
    return cachedGatewayName as string;
  } catch (error) {
    throw error;
  } finally {
    // Clear the promise cache after completion (success or failure)
    gatewayNamePromise = null;
  }
};
